import { STORAGE_KEYS } from '@/constants/CheckoutConstants'
import { useSessionStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export type DoiConfirmationStatus = 'confirmed' | 'invalid'

export const useDoiOptInStore = defineStore('doiOptIn', {
  state: () => ({
    hasOptedInThisPurchase: useSessionStorage(
      STORAGE_KEYS.DOI_OPTED_IN_THIS_PURCHASE,
      false
    ),
    // Whether the cart-page checkbox is currently ticked. Submission is deferred
    // until the "go to checkout" button is clicked (VIP-12044), so this just holds
    // the UI state in between — no need to persist it across reloads.
    cartCheckboxChecked: false,
    // Outcome of the ?doi= landing after the confirmation mail was clicked
    // (VIP-12046). Not persisted on purpose: the popup belongs to that one
    // landing, a reload must not show it again.
    doiConfirmation: null as DoiConfirmationStatus | null,
    // Voucher code minted by that confirmation, shown in the popup. Only the
    // first click carries one; the voucher mail is the durable copy.
    doiVoucherCode: null as string | null
  }),
  actions: {
    markOptedIn() {
      this.hasOptedInThisPurchase = true
    },
    showDoiConfirmation(
      status: DoiConfirmationStatus,
      voucherCode: string | null = null
    ) {
      this.doiConfirmation = status
      this.doiVoucherCode = voucherCode
    },
    dismissDoiConfirmation() {
      this.doiConfirmation = null
      this.doiVoucherCode = null
    }
  }
})
